import { nsT, useT } from '../../index';
import type zh from './zh-CN';

export type PublicMessages = typeof zh;
export const usePublicT = () => useT<PublicMessages>('public');
export const publicT = nsT<PublicMessages>('public');
